import React from 'react';
import { AdoptsModalType } from './constants';
import BuyerModalLoadable from './modals/BuyerModalLoadable';
import SellerModalLoadable from './modals/SellerModalLoadable';
export const adoptsModalRenderer = (modalType, requestClose, params)=>{
    switch(modalType){
        case AdoptsModalType.BUYER_MODAL:
            return /*#__PURE__*/ React.createElement(BuyerModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation,
                initialScreen: params.initialScreen
            });
        case AdoptsModalType.SELLER_MODAL:
            return /*#__PURE__*/ React.createElement(SellerModalLoadable, {
                onRequestClose: requestClose,
                deviation: params.deviation,
                initialScreen: params.initialScreen
            });
        default:
            return null;
    }
};
